import { Box } from '@mui/material';
import { OptionsMenu } from 'framework/ui/menu';
import ListTableActionButton from './ListTableActionButton';
import type { ListTableAction, ListTableProps, ListTableRow } from './types';
import { getVisibleActions } from './utils';

interface ListTableRowActionsProps<Row extends ListTableRow> {
  row: Row;
  rowActions: NonNullable<ListTableProps<Row>['rowActions']>;
  menuActions: ListTableAction<Row>[];
}

const ListTableRowActions = <Row extends ListTableRow>({
  row,
  rowActions,
  menuActions,
}: ListTableRowActionsProps<Row>) => {
  const filteredRowActions = getVisibleActions(rowActions.actions ?? [], row);
  const maxActions = Math.max(0, rowActions.maxActions ?? filteredRowActions.length);
  const visibleRowActions = filteredRowActions.slice(0, maxActions);
  const visibleMenuActions = [...filteredRowActions.slice(maxActions), ...getVisibleActions(menuActions, row)];
  if (!visibleRowActions.length && !visibleMenuActions.length) return null;

  return (
    <Box display="flex" justifyContent="flex-start" alignItems="center" gap={0.5}>
      {visibleRowActions.map(action => (
        <ListTableActionButton
          key={action.id}
          action={action}
          disabled={action.isDisabled?.(row)}
          onClick={() => action.onClick(row)}
        />
      ))}
      {visibleMenuActions.length > 0 && (
        <OptionsMenu
          ariaLabel={`More actions for row ${row.id}`}
          options={visibleMenuActions.map(action => ({
            key: action.id,
            label: action.label,
            icon: action.icon,
            disabled: action.isDisabled?.(row),
            onClick: () => action.onClick(row),
          }))}
          data={row}
        />
      )}
    </Box>
  );
};

export default ListTableRowActions;
